import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  all: {},
  instantOrders: {},
  sameDayOrders: {},

  loading: false,
  connected: false,

  codReport: {},
  codLoading: false,

  expressOrdersReport: [],
  expressReportLoading: false,
})

const { Types, Creators } = createActions({
  syncExpress: null,
  setExpress: ['data'],
  setInstantOrders: ['data'],
  setSameDayOrders: ['data'],
  setConnected: ['val'],
  setExpressLoading: ['val'],

  getCodReport: ['payload'],
  setCodReport: ['payload'],
  setSingleCodReport: ['payload'],
  setExpressCodLoading: ['val'],

  getExpressOrdersReport: ['payload'],
  setExpressOrdersReport: ['data'],
})

export const setExpressReducer = (state, { data }) => state.set('all', data)

export const setInstantOrdersReducer = (state, { data }) => state.set('instantOrders', data)

export const setSameDayOrdersReducer = (state, { data }) => state.set('sameDayOrders', data)

export const setConnectedReducer = (state, { val }) => state.set('connected', val)

export const setExpressLoadingReducer = (state, { val }) => state.set('loading', val)

export const getCodReportReducer = state => state.set('codLoading', true)

export const setCodReportReducer = (state, { payload }) => state.set('codLoading', false).set('codReport', payload.data)

export const setExpressCodLoadingReducer = (state, { val }) => state.set('codLoading', val)

export const setSingleCodReportReducer = (state, { payload }) => state.setIn(['codReport', payload.id], payload)

export const getExpressOrdersReportReducer = (state) => state.set('expressReportLoading', true)

export const setExpressOrdersReportReducers = (state, { data }) => state
  .set('expressOrdersReport', data)
  .set('expressReportLoading', false)

export const expressReducer = createReducer(INITIAL_STATE, {
  [Types.SET_EXPRESS]: setExpressReducer,
  [Types.SET_INSTANT_ORDERS]: setInstantOrdersReducer,
  [Types.SET_SAME_DAY_ORDERS]: setSameDayOrdersReducer,
  [Types.SET_CONNECTED]: setConnectedReducer,

  [Types.SET_EXPRESS_LOADING]: setExpressLoadingReducer,

  [Types.GET_COD_REPORT]: getCodReportReducer,
  [Types.SET_COD_REPORT]: setCodReportReducer,
  [Types.SET_SINGLE_COD_REPORT]: setSingleCodReportReducer,
  [Types.SET_EXPRESS_COD_LOADING]: setExpressCodLoadingReducer,

  [Types.GET_EXPRESS_ORDERS_REPORT]: getExpressOrdersReportReducer,
  [Types.SET_EXPRESS_ORDERS_REPORT]: setExpressOrdersReportReducers,
})

export const ExpressTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/expressReducer.js